export default function HomeTwoTeam(){
    return(
        <>
            <section className="team-area pt-120 pb-90 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30">
			<div className="container">
				<div className="row justify-content-center">
					<div className=" col-lg-8">
						<div className="services-title2 text-center mb-55">
							<h2 className="style-text">Team</h2>
							<h6 className="semi-title semi-title2 pl-0">team</h6>
							<h2 className="sect-title">Company Exparts</h2>
						</div>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper mb-30">
							<div className="team-thumb">
								<img src="assets/img/team/team-1.jpg" alt="Image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<a className="twitter" href="#"><i className="fab fa-twitter"></i></a>
											<a className="google" href="#"><i className="fab fa-youtube"></i></a>
											<a className="behance" href="#"><i className="fab fa-instagram"></i></a>
											<a className="fb" href="#"><i className="fab fa-facebook-f"></i></a>
											<a className="plus" href="#"><i className="fal fa-plus"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content text-lg-start">
								<h6>Founder</h6>
								<h4 className="sub-title">Rosalina D. William</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper mb-30">
							<div className="team-thumb">
								<img src="assets/img/team/team-2.jpg" alt="Image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<a className="twitter" href="#"><i className="fab fa-twitter"></i></a>
											<a className="google" href="#"><i className="fab fa-youtube"></i></a>
											<a className="behance" href="#"><i className="fab fa-instagram"></i></a>
											<a className="fb" href="#"><i className="fab fa-facebook-f"></i></a>
											<a className="plus" href="#"><i className="fal fa-plus"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content text-lg-start">
								<h6>CEO</h6>
								<h4 className="sub-title">Miranda H. Halim</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper mb-30">
							<div className="team-thumb">
								<img src="assets/img/team/team-3.jpg" alt="Image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<a className="twitter" href="#"><i className="fab fa-twitter"></i></a>
											<a className="google" href="#"><i className="fab fa-youtube"></i></a>
											<a className="behance" href="#"><i className="fab fa-instagram"></i></a>
											<a className="fb" href="#"><i className="fab fa-facebook-f"></i></a>
											<a className="plus" href="#"><i className="fal fa-plus"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content text-lg-start">
								<h6>Designer</h6>
								<h4 className="sub-title">Alexis J. Jhalmuri</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper mb-30">
							<div className="team-thumb">
								<img src="assets/img/team/team-4.jpg" alt="Image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<a className="twitter" href="#"><i className="fab fa-twitter"></i></a>
											<a className="google" href="#"><i className="fab fa-youtube"></i></a>
											<a className="behance" href="#"><i className="fab fa-instagram"></i></a>
											<a className="fb" href="#"><i className="fab fa-facebook-f"></i></a>
											<a className="plus" href="#"><i className="fal fa-plus"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content text-lg-start">
								<h6>Marketer</h6>
								<h4 className="sub-title">Piona L. Limonda</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>	
        </>
    )
}